
import React from "react";

export default function Logs() {

  return (
    <div>
      OrderLogs.js
    </div>
  );
}



